import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'

import { prepareData } from 'helpers/prepare-req-data'
import { prepParams } from 'helpers/prep-req-url'
import { getRespData  } from 'helpers/get-resp-data'
import client from 'api'
import _ from 'lodash'

import { v4 as uuid4 } from 'uuid'


const initialState = {
    startProcess404052ParamStatus: 'idle',
    startProcess404052ParamError: undefined as any,
    loadUserParamsProcess404052ParamStatus: 'idle',
    loadUserParamsProcess404052ParamError: undefined as any,

    process404052ParamList: [] as any[],
    defaultValues: undefined as any,
    job: undefined as any,
    filterValues: {} as any,
    filterLookupValues: {} as any,

    directLoad: false,
    load: false,
    activeDivRef: null as any,

    filterValuesId: null,
    valuesFromDB: false,
    filterVisibleId: null,
    filterVisible: true,
}


export const startProcess404052Param = createAsyncThunk('process404052ParamSlice/startProcess404052Param', async ({ process404052Param }: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.post(
        `/api/ixweb/StartProcess404052Param/`,
        prepareData(process404052Param),
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: value1.map((x: any) => ({
            ...x,
        })),
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { startProcess404052ParamStatus } = getState().process404052ParamSlice
        return startProcess404052ParamStatus !== 'pending'
    }
})

export const loadUserParamsProcess404052Param = createAsyncThunk('process404052ParamSlice/loadUserParamsProcess404052Param', async (_: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.get(
        `/api/ixweb/LoadUserParamsProcess404052Param/`,
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: value1.map((x: any) => ({
            ...x,
        })),
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { loadUserParamsProcess404052ParamStatus } = getState().process404052ParamSlice
        return loadUserParamsProcess404052ParamStatus !== 'pending'
    }
})

const Process404052ParamSlice = createSlice({
    name: 'process404052ParamSlice',
    initialState,
    reducers: {
        resetstartProcess404052Param: (state) => {
            state.job = undefined
            state.startProcess404052ParamError = undefined
        },
        resetstartProcess404052ParamError: (state) => {
            state.startProcess404052ParamError = undefined
        },
        resetloadUserParamsProcess404052Param: (state) => {
            state.defaultValues = undefined
            state.loadUserParamsProcess404052ParamError = undefined
        },
        resetloadUserParamsProcess404052ParamError: (state) => {
            state.loadUserParamsProcess404052ParamError = undefined
        },
        removeFromProcess404052ParamListById: (state, action) => {
            state.process404052ParamList = state.process404052ParamList.filter((x: any) => x.HDR_ID !== action.payload)
        },
        removeFromProcess404052ParamListByIds: (state, action) => {
            state.process404052ParamList = state.process404052ParamList.filter((x: any) => action.payload.indexOf(x.HDR_ID) === -1)
        },
        setFilterValues: (state, action) => {
            if (action.payload === undefined || action.payload === null) {
                state.filterValues = {}
            } else {
                state.filterValues = { ...state.filterValues, ...action.payload }
            }
        },
        setFilterLookupValue: (state, action) => {
            const { name, value, formValue } = action.payload
            if (name) {
                state.filterLookupValues[name] = value
                state.filterValues[name] = formValue
            }
        },
        setDirectLoad: (state, action) => { state.directLoad = action.payload },
        setLoad: (state, action) => { state.load = action.payload },
        setActiveDivRef: (state, action) => { state.activeDivRef = action.payload},
        setFilterValuesId: (state, action) => {
            state.filterValuesId = action.payload
        },
        setValuesFromDB: (state, action) => {
            state.valuesFromDB = action.payload
        },
        setFilterVisibleId: (state, action) => {
            state.filterVisibleId = action.payload
        },
        setFilterVisible: (state, action) => {
            state.filterVisible = action.payload
        },
        preloadData: (state, action) => {
            state.process404052ParamList = action.payload.map((x: any) => ({ ...x, HDR_ID: uuid4()}))
            state.startProcess404052ParamStatus = 'preloaded'
        },
        clearPreloadedData: (state) => {
            state.process404052ParamList = []
            state.startProcess404052ParamStatus = 'idle'
        },
    },
    extraReducers: builder => {
        builder.addCase(startProcess404052Param.pending, (state) => {
            state.startProcess404052ParamStatus = 'pending'
            state.startProcess404052ParamError = undefined
        })
        builder.addCase(startProcess404052Param.fulfilled, (state, action) => {
            state.startProcess404052ParamStatus = 'idle'

            {
                state.job = action.payload

            }
        })
        builder.addCase(startProcess404052Param.rejected, (state, action) => {
            state.startProcess404052ParamStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.startProcess404052ParamError = action.error.message
            } else {
                state.startProcess404052ParamError = action.payload
            }
        })

        builder.addCase(loadUserParamsProcess404052Param.pending, (state) => {
            state.loadUserParamsProcess404052ParamStatus = 'pending'
            state.loadUserParamsProcess404052ParamError = undefined
        })
        builder.addCase(loadUserParamsProcess404052Param.fulfilled, (state, action) => {
            state.loadUserParamsProcess404052ParamStatus = 'idle'

            {
                state.defaultValues = action.payload

            }
        })
        builder.addCase(loadUserParamsProcess404052Param.rejected, (state, action) => {
            state.loadUserParamsProcess404052ParamStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.loadUserParamsProcess404052ParamError = action.error.message
            } else {
                state.loadUserParamsProcess404052ParamError = action.payload
            }
        })

    }
})

export const {
    resetstartProcess404052Param,
    resetstartProcess404052ParamError,
    resetloadUserParamsProcess404052Param,
    resetloadUserParamsProcess404052ParamError,
    removeFromProcess404052ParamListById,
    removeFromProcess404052ParamListByIds,
    setFilterValues,
    setFilterLookupValue,
    setDirectLoad,
    setLoad,
    setActiveDivRef,
    setFilterValuesId,
    setValuesFromDB,
    setFilterVisible,
    setFilterVisibleId,
    preloadData,
    clearPreloadedData,
} = Process404052ParamSlice.actions
export default Process404052ParamSlice.reducer
